var React = require('react');

function ChevLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.408456 9.98105C0.411906 9.53285 0.589806 9.10396 0.903896 8.78505L9.17849 0.510586C9.8508 -0.164824 10.9434 -0.167234 11.6188 0.505066C12.2942 1.17737 12.2966 2.26994 11.6243 2.94534L4.56713 10.0024L11.6243 17.0595C12.2966 17.7349 12.2942 18.8275 11.6188 19.4998C10.9434 20.1721 9.8508 20.1697 9.17849 19.4943L0.903896 11.2198C0.579116 10.8902 0.400526 10.4437 0.408456 9.98106V9.98105Z","fill":"#041E42"}));
}

ChevLeft.defaultProps = {"width":"13","height":"21","viewBox":"0 0 13 21","fill":"none"};

module.exports = ChevLeft;

ChevLeft.default = ChevLeft;
